import { buildHoldDocId } from "./allocationTypes";

/**
 * @typedef {import('./allocationTypes').AllocationHold} AllocationHold
 */

/**
 * @param {AllocationHold | null | undefined} existing
 * @param {string} matchId
 * @param {boolean} allowConcurrentExclusive
 */
export function canAcquireExclusiveHold(existing, matchId, allowConcurrentExclusive) {
  if (!existing || existing.state !== "held") return { ok: true };
  if (existing.matchId === matchId) return { ok: true };
  if (allowConcurrentExclusive) return { ok: true };
  return { ok: false, code: "ALLOCATION_CONFLICT", competingMatchId: existing.matchId };
}

/**
 * @param {Object} params
 * @param {string} params.competitionId
 * @param {string} params.matchId
 * @param {'participant' | 'resource'} params.targetType
 * @param {string} params.targetId
 * @param {number} params.nowMs
 * @param {number} [params.epoch]
 * @returns {AllocationHold}
 */
export function createHoldRecord({
  competitionId,
  matchId,
  targetType,
  targetId,
  nowMs,
  epoch = 1,
}) {
  return {
    holdId: buildHoldDocId(competitionId, targetType, targetId),
    competitionId,
    matchId,
    targetType,
    targetId,
    mode: "exclusive",
    state: "held",
    allocationEpoch: epoch,
    heldAtMs: nowMs,
    releasedAtMs: null,
  };
}

/**
 * @param {AllocationHold} hold
 * @param {number} nowMs
 * @returns {AllocationHold}
 */
export function releaseHold(hold, nowMs) {
  if (!hold || hold.state === "released") return hold;
  return { ...hold, state: "released", releasedAtMs: nowMs };
}

/**
 * @param {AllocationHold[]} holds
 * @returns {{ participantIdToMatchId: Record<string, string>, resourceIdToMatchId: Record<string, string> }}
 */
export function buildActiveHoldsProjection(holds) {
  /** @type {Record<string, string>} */
  const participantIdToMatchId = {};
  /** @type {Record<string, string>} */
  const resourceIdToMatchId = {};
  (holds || []).forEach((h) => {
    if (!h || h.state !== "held") return;
    if (h.targetType === "participant") participantIdToMatchId[h.targetId] = h.matchId;
    else resourceIdToMatchId[h.targetId] = h.matchId;
  });
  return { participantIdToMatchId, resourceIdToMatchId };
}
